#import "../../../../../../../common/graphql/EntityDocumentsFields.graphql"
query AppliableInvoiceSigningDocuments(
  $first: Int
  $after: Cursor
  $invoiceId: UUID
  $businessUnitId: UUID
  $documentTypeId: Int
  $transactionTypeId: Int
  $currencyId: Int
  $departmentId: UUID
  $cardHolderId: UUID
  $orderBy: [EntityDocumentsOrderBy!]
  $filter: EntityDocumentFilter
  $transactionAmount: BigFloat
) {
  appliableInvoiceSigningDocuments(
    first: $first
    after: $after
    invoiceId: $invoiceId
    documentTypeId: $documentTypeId
    businessUnitId: $businessUnitId
    transactionTypeId: $transactionTypeId
    currencyId: $currencyId
    departmentId: $departmentId
    cardHolderId: $cardHolderId
    orderBy: $orderBy
    filter: $filter
    transactionAmount: $transactionAmount
  ) {
    nodes {
      _isDocumentDistributionAttachable
      _isDocumentAmountAccumulated
      _isDocumentReceiptAccumulated
      _isDocumentAmountAccumulated
      ...EntityDocumentsFields
      documentPosition
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
